import React from "react";
// import clsx from "clsx";
import PropTypes from "prop-types";
import {makeStyles } from "@material-ui/core/styles";
// import AlertComponent from "../../../../_metronic/_helpers/AlertComponent";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress/index";

const headRows = [
  {
    id: "assetName",
    numeric: false,
    disablePadding: true,
    label: "Asset name",
  },
  {
    id: "employeeCount",
    numeric: false,
    disablePadding: true,
    label: "Employee count",
  },
  {
    id: "usageHistoryCount",
    numeric: false,
    disablePadding: true,
    label: "Usage history count",
  },
];

function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,
  } = props;

  return (
    <TableHead>
      <TableRow>
        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? "right" : "left"}
            padding={row.disablePadding ? "none" : "default"}
            sortDirection={orderBy === row.id ? false : false}
            className="px-4  pb-2 pt-2"
          >
            <TableSortLabel
              active={orderBy === row.id}
              direction={order ? "asc" : "desc"}
              onClick={() => {
                return row.id !== "tools" ? onRequestSort(row.id) : null;
              }}
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.bool.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

// const useToolbarStyles = makeStyles((theme) => ({
//   root: {
//     paddingLeft: theme.spacing(2),
//     paddingRight: theme.spacing(1),
//   },
//   highlight:
//     theme.palette.type === "light"
//       ? {
//           color: theme.palette.secondary.main,
//           backgroundColor: lighten(theme.palette.secondary.light, 0.85),
//         }
//       : {
//           color: theme.palette.text.primary,
//           backgroundColor: theme.palette.secondary.dark,
//         },
//   spacer: {
//     flex: "1 1 100%",
//     display: "flex",
//     justifyContent: "flex-end",
//   },
//   actions: {
//     color: theme.palette.text.secondary,
//   },
//   title: {
//     flex: "0 0 auto",
//   },
// }));

const EnhancedTableToolbar = (props) => {
  // const classes = useToolbarStyles();

  return (

    <Toolbar className="toolbar-design">
      <div>
      </div>
    </Toolbar>
  );
};



const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  toolbar: {
    minHeight: theme.spacing(2),
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#63C059",
  },
}));

export default function EnhancedTable(props) {
  const {
    setSortField,
    setOrderByTable,
    sortField,
    orderBy,
    isLoaded,
    error,
    rows,
    updateTake,
    setDeleteWishListsID,
    onWishListsExport,
  } = props;
  const classes = useStyles();


  function handleRequestSort(property) {
    const isDesc = sortField === property && !orderBy;

    setOrderByTable(isDesc);
    setSortField(property);
    updateTake(10);

  }

  function handleSelectAllClick(event) {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);

      setDeleteWishListsID(newSelecteds);
      return;
    }

    setDeleteWishListsID([]);
  }


  let i = 1;
  return (
    <div className="col-12">
      <div className={classes.root}>
        <Paper className={classes.paper}>
          {isLoaded && !rows.length && (
            <div className={classes.progresRoot}>
              <CircularProgress className={classes.progress} />
            </div>
          )}
          <EnhancedTableToolbar
            onWishListsExport={onWishListsExport}
          />
          <div  className={classes.tableWrapper} style={{overflowX:"hidden"}}>
            {rows.length ? (
              <Table className={classes.table} aria-labelledby="tableTitle">
                <EnhancedTableHead
                  order={orderBy}
                  orderBy={sortField}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                />
                <TableBody>
                  {rows.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                      >
                   
                        <TableCell padding="none" className="pr-4 px-4">
                          {i++}. {row.assetName}
                        </TableCell>
                        <TableCell padding="none" className="pr-4   py-4 px-4">
                          {row.employeeCount}
                        </TableCell>
                        <TableCell padding="none" className="pr-4   py-4 px-4">
                          {row.usageHistoryCount}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            ) : !rows.length && !isLoaded && !error ? (
              // <AlertComponent variant="info" message="No information found" />
              <div className="noInfo"><img src="./media/error/search2.png" alt="information"/>
              <h4>No information found</h4></div>
            ) : (
              !isLoaded &&
              error && (
                // <AlertComponent
                //   variant="danger"
                //   message="We've lost the connection"
                // />
                <div className="noInfo"><img src="./media/error/connection.png" className="info-img" alt="connection" />
                <h4>We've lost the connection</h4></div>
              )
            )}
          </div>
        </Paper>
      </div>
    </div>
  );
}
